export default __webpack_public_path__ + "static/media/youtube.31ab75fc.svg";